import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface TypeCarteSelectProps {
    setSelectedTypeCarte: (type: string) => void;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const TypeCarteSelect: React.FC<TypeCarteSelectProps> = ({ setSelectedTypeCarte }) => {
    const typeCartes: string[] = ['Provision', 'Crédit'];

    const options: ISelectOption[] = typeCartes.map((type) => ({
        value: type,
        label: type,
    }));

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedTypeCarte(selectedOption ? selectedOption.value : '');
    };

    return <Select id="autoSizingSelect" options={options} onChange={handleChange} placeholder={'--- Type carte'} isClearable isSearchable styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default TypeCarteSelect;
